<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

import { useConsentManager } from '@/composables/useConsentManager';

const { shouldInit, destroyConsentManager, initConsentManager } = useConsentManager();

onMounted(async () => {
  if (shouldInit()) {
    await initConsentManager();
  }
});

onUnmounted(() => {
  destroyConsentManager();
});
</script>

<template>
  <div :style="{ display: 'none' }" />
</template>
